import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { GameHostingPage } from './pages/GameHostingPage';
import { WebHostingPage } from './pages/WebHostingPage';
import { VPSPage } from './pages/VPSPage';
import { DedicatedPage } from './pages/DedicatedPage';
import { ColocationPage } from './pages/ColocationPage';
import { IPTransitPage } from './pages/IPTransitPage';
import { NetworkPage } from './pages/NetworkPage';
import { ContactPage } from './pages/ContactPage';
import { FAQPage } from './pages/FAQPage';
import { TermsPage } from './pages/legal/TermsPage';
import { PrivacyPage } from './pages/legal/PrivacyPage';
import { CookiesPage } from './pages/legal/CookiesPage';
import { AbusePage } from './pages/AbusePage';
import { LoadingScreen } from './components/LoadingScreen';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      <BrowserRouter>
        <div className={`min-h-screen bg-gray-100 flex flex-col transition-opacity duration-1000 ${
          isLoading ? 'opacity-0' : 'opacity-100'
        }`}>
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/game-hosting" element={<GameHostingPage />} />
              <Route path="/web-hosting" element={<WebHostingPage />} />
              <Route path="/vps" element={<VPSPage />} />
              <Route path="/dedicated" element={<DedicatedPage />} />
              <Route path="/colocation" element={<ColocationPage />} />
              <Route path="/ip-transit" element={<IPTransitPage />} />
              <Route path="/network" element={<NetworkPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/abuse" element={<AbusePage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App